import { Component, EventEmitter, Input, Output } from '@angular/core';
import { formatCPFOrCNPJ } from 'src/app/helpers/utils/cpf-cnpj.util';
import { Beneficiaries } from 'src/app/shared/interfaces/beneficiaries';

@Component({
  standalone: false,
  selector: 'app-modal-details-retirement',
  templateUrl: './modal-details-retirement.component.html',
  styleUrls: ['./modal-details-retirement.component.scss'],
})
export class ModalDetailsRetirementComponent {
  @Input() isOpen = false;
  @Output() isOpenChange = new EventEmitter<boolean>();
  @Input() beneficiary: Beneficiaries | null = null;

  get documentFieldLabel(): string {
    return this.beneficiary?.foreignerIndicator ? 'TAX ID' : 'CPF/CNPJ';
  }

  get formattedDocumentNumber(): string {
    const documentNumber = this.beneficiary?.documentNumber;
    if (!documentNumber) {
      return '';
    }
    if (this.beneficiary?.foreignerIndicator) {
      return documentNumber;
    }
    return formatCPFOrCNPJ(documentNumber);
  }

  close(): void {
    this.isOpen = false;
    this.isOpenChange.emit(false);
  }
}
